module.exports = __webpack_public_path__ + "static/39FEA2_7_0-43abf24646f9c5fb8bf7a06da60d41bd.woff2";